export const backendEndpoint = 'https://wordle-backend-sfbd.onrender.com';
export const socketEndpoint = 'https://wordle-backend-sfbd.onrender.com';
